import {DashboardSearchEngineRecordTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function dashboardSearchEngineRecordTypeNameFilter(type: DashboardSearchEngineRecordTypeEnum): string {
  switch (type) {
    case DashboardSearchEngineRecordTypeEnum.Driver: return i18n.t(LF.Drivers) as string;
    case DashboardSearchEngineRecordTypeEnum.Vehicle: return i18n.t(LF.Vehicle) as string;
    case DashboardSearchEngineRecordTypeEnum.ApplicationAccount: return i18n.t(LF.ApplicationAccounts) as string;
    case DashboardSearchEngineRecordTypeEnum.Settlement: return i18n.t(LF.Settlements) as string;
  }
}
